// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const ItemsLine = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
`;
